import { isInvalidRoutePath } from "~/utils/isInvalidRoutePath";

export default defineNuxtRouteMiddleware((to) => {
  if (isInvalidRoutePath(to.path)) {
    return navigateTo("/", { redirectCode: 302 });
  }
});
